import { call, select } from 'redux-saga/effects'

import { convertOpeningGroupsToDrawableLocations } from './data-prep/convertOpeningsToDrawableLocations'
import { OpeningAPI, OpeningGroupAPI } from '../../../models/activeDrawable'
import { getCurrentDrawableLocationsFromRootState } from '../../slices/2D'
import { GeometricDrawable, GeometryGroup } from '../../slices/geometry'
import { IMUP2DDrawableLocation } from '../../types'

export function* calculateNewDrawableLocations(newGroups: OpeningGroupAPI[] | GeometryGroup[]) {
    const groupOpeningIds: number[] = yield newGroups.flatMap((group: OpeningGroupAPI | GeometryGroup) => {
        return group.openings.map((op: OpeningAPI | GeometricDrawable) => op.id)
    })

    const currentDrawableLocations: IMUP2DDrawableLocation[] = yield select(getCurrentDrawableLocationsFromRootState)

    const unAffectedDrawableLocations: IMUP2DDrawableLocation[] = yield currentDrawableLocations.filter(
        (loc) => !groupOpeningIds.includes(loc.drawable_id)
    )

    const newDrawableLocations: IMUP2DDrawableLocation[] = yield call(
        convertOpeningGroupsToDrawableLocations,
        newGroups
    )

    return {
        additionalDrawableLocations: newDrawableLocations,
        newDrawableLocations: [...newDrawableLocations, ...unAffectedDrawableLocations],
    }
}
